module.exports = __webpack_public_path__ + "media/images/emblems/Pfaeffikon-blazon-35db65466bf10c1bc42d29d550647917.svg";